import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
// Live Buyer Popup Component
const NAMES = ['Martín', 'Carolina', 'Federico', 'Sofía', 'Diego', 'Laura', 'Juan', 'Agustina', 'Lucas', 'Camila', 'Tomás', 'Valentina', 'Matías', 'Julieta', 'Nicolás'];
const CITIES = ['Buenos Aires', 'Ciudad de México', 'Bogotá', 'Santiago', 'Lima', 'Montevideo', 'Madrid', 'Guadalajara', 'Medellín', 'Monterrey', 'Asunción', 'Quito', 'San José', 'Panamá', 'Barcelona'];
export function BuyerPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    // First popup appears after 30s, then repeats every 30s
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 30000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
    setBuyer({
      name: randomName,
      city: randomCity,
      time: randomTime
    });
    setIsVisible(true);
    // Hide after 5 seconds visible, then schedule next one 25s later (= 30s cycle)
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(showRandomBuyer, 25000);
    }, 5000);
  };
  return <AnimatePresence data-id="element-112" data-mp="po76sd35gi7o">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 bg-[#0b1628] rounded-2xl shadow-2xl border border-white/10 p-4 pr-10 max-w-[calc(100vw-2rem)] sm:max-w-sm flex items-center gap-4" data-id="element-113" data-mp="kpvw605163oe">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-500 hover:text-slate-300" aria-label="Cerrar notificación" data-id="element-114" data-mp="2t0mxs4e6dnpx">
            <X className="w-4 h-4" data-id="element-115" data-mp="2k4dwslajuh1o" />
          </button>

          <div className="w-10 h-10 rounded-full bg-cyan-500/15 text-cyan-400 flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-116" data-mp="2oy09gdgpqkxh">
            {buyer.name.charAt(0)}
          </div>

          <div data-id="element-117" data-mp="2f870lk7ygjwx">
            <p className="text-sm text-slate-200 font-medium leading-tight mb-1" data-id="element-118" data-mp="2f7ngpxyqvlg9">
              <span className="font-bold text-white" data-id="element-119" data-mp="218fj39i8cle6">{buyer.name}</span> de{' '}
              {buyer.city} acaba de comprar PADEL 360
            </p>
            <div className="flex items-center gap-1 text-xs text-slate-500" data-id="element-120" data-mp="25aso1vp5kf9w">
              <CheckCircle2 className="w-3 h-3 text-cyan-400" data-id="element-121" data-mp="1mkxjuqnfsiz5" />
              <span data-id="element-122" data-mp="1hmmb6j8voeii">Verificado • hace {buyer.time} min</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
// Sticky CTA Component
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero section (approx 600px)
      // Hide it when reaching the pricing section to avoid double CTAs
      const scrollY = window.scrollY;
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        const pricingTop = pricingSection.offsetTop;
        setIsVisible(scrollY > 600 && scrollY < pricingTop - 500);
      } else {
        setIsVisible(scrollY > 600);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-123" data-mp="37ctfutb3myev">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} className="fixed bottom-6 right-6 z-40 hidden md:block" data-id="element-124" data-mp="3c4un20tetyy1">
          <button onClick={scrollToPricing} className="bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-heading font-extrabold py-4 px-8 rounded-full shadow-2xl shadow-cyan-500/30 transition-transform hover:scale-105 flex items-center gap-2 uppercase tracking-wide text-base" data-id="element-125" data-mp="2ogjr9c2kmpgm">
            Quiero mi acceso →
          </button>
        </motion.div>}
    </AnimatePresence>;
}